export default "__VITE_ASSET__irHsMpTK__"